"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetricsIcon = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size"];

var MetricsIcon = function MetricsIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    "data-testid": "MetricsIcon",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: _style["default"].dynamic([["1057289449", [size, size]]]) + " " + (props && props.className != null && props.className || "")
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 11L6 6L10 10L14 5",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "6",
    cy: "6",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "10",
    cy: "10",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "14",
    cy: "5",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2",
    cy: "11",
    r: "1.5",
    fill: color,
    className: _style["default"].dynamic([["1057289449", [size, size]]])
  }), /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "1057289449",
    dynamic: [size, size]
  }, ["svg.__jsx-style-dynamic-selector{height:".concat(size, "px;width:").concat(size, "px;display:block;}")]));
};

exports.MetricsIcon = MetricsIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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